export default __webpack_public_path__ + "static/media/fuel.a9aab9f4.svg";